const localStorageKeys = Object.freeze({
  JARVIS_TOKEN_KEY: '@Compliance:token',
  JARVIS_ORGANIZATION_KEY: '@Compliance:organizationId'
})

export default localStorageKeys
